import mutations from './patientEvidenceNonValidatedDocuments.mutations'
import actions from './patientEvidenceNonValidatedDocuments.actions'
import getters from './patientEvidenceNonValidatedDocuments.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
